<template>
  <v-container class="pb-10">
    <v-btn icon @click="goBack" class="mb-2">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>

    <h1 class="text-h4">{{ item.term }}</h1>
    <p class="mt-4">{{ item.meaning }}</p>
    <v-btn outlined :to="{ name: 'ItemEdit', params: { id: item.id } }">
      <v-icon left>mdi-pencil</v-icon> Edit
    </v-btn>

    <v-btn icon class="ml-4" @click="deleteConfirmation(item.id)">
      <v-icon color="grey lighten-1">mdi-delete</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: mapGetters(["item"]),

  methods: {
    ...mapActions(["deleteItem"]),

    deleteConfirmation(id) {
      if (confirm("Delete this item?")) {
        this.deleteItem(id);
      }
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
